import AggregateError from "es-aggregate-error";

import { currentEnv, Env } from "./env";
import { APIError } from "./errors";

export async function executeWithRetry<T>(
  callback: (context: { attempts: number; startTime: Date }) => Promise<T>,
  retryCount: number,
  delayBetweenRetriesMs = 100
) {
  let attempts = 0;
  let lastError;
  const startTime = new Date();
  while (attempts < retryCount) {
    try {
      return await callback({ attempts, startTime });
    } catch (err) {
      attempts = attempts + 1;
      lastError = err;

      // if error has `skipRetry` flag, don't attempt to retry
      if (
        (err instanceof AggregateError && APIError.instanceof(err.errors[0]) && err.errors[0]?.skipRetry) ||
        (APIError.instanceof(err) && err.skipRetry)
      ) {
        break;
      }

      // don't retry if we are just running from local env
      if (currentEnv() === Env.Local) {
        break;
      }

      await new Promise((resolve) => setTimeout(resolve, delayBetweenRetriesMs));
    }
  }
  return Promise.reject(lastError);
}
